import React from 'react';
import {FieldViewProps} from "../../../render/view";
import Task from "../../../../model2/task/task";

export default function FieldReminder_ViewSmall(props:FieldViewProps) {

    const task = _.get(props.model, props.field.fieldId, null) as Task

    if (!task) return null

    const classes = Classes("flex-row-left-center ", "", props.className, {
        // 'invalid-value': !props.field.isValueValid(value)
    })

    return (
        <div className={classes}>
            not implemented
            {/*<div className="ui5-property flex-no-shrink not-selectable m-r-5">#{task.shortId}</div>*/}
            {/*<span className="ui5-txt-default txt-truncate no-wrap">{task.title}</span>*/}
        </div>
    );
}
